import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ObjectEntity } from './object.entity';
import { ProcessDefinitionEntity } from './process-definition.entity';
import { ProcessTypeEntity } from './process-type.entity';

@Index('process__object__fk__object__id_fk', ['fkObjectId'], {})
@Index(
	'process__object__fk_process_definition__id_fk',
	['fkProcessDefinitionId'],
	{},
)
@Index('process__object__fk_process_type__id_fk', ['fkProcessTypeId'], {})
@Entity('process__object')
export class ProcessObjectEntity extends BaseEntity {
	@Column('int', { name: '_fk_process_definition__id', unsigned: true })
	public fkProcessDefinitionId!: number;

	@Column('int', { name: '_fk__object__id', unsigned: true })
	public fkObjectId!: number;

	@Column('int', {
		name: '_fk_process_type__id',
		nullable: true,
		unsigned: true,
	})
	public fkProcessTypeId!: number | null;

	@ManyToOne(
		() => ProcessDefinitionEntity,
		(processDefinition) => processDefinition.processObjects,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk_process_definition__id', referencedColumnName: 'id' },
	])
	public fkProcessDefinition!: ProcessDefinitionEntity;

	@ManyToOne(
		() => ProcessTypeEntity,
		(processType) => processType.processObjects,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk_process_type__id', referencedColumnName: 'id' }])
	public fkProcessType!: ProcessTypeEntity;

	@ManyToOne(() => ObjectEntity, (object) => object.processObjects, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__object__id', referencedColumnName: 'id' }])
	public fkObject!: ObjectEntity;
}
